
import { supabase } from "@/integrations/supabase/client";

export const createSubscription = async (
  userId: string,
  planId: string,
  clientId: string,
  duration: number
) => {
  const { data: subscription, error } = await supabase
    .from('subscriptions')
    .insert([{
      user_id: userId,
      plan_id: planId,
      client_id: clientId,
      status: 'pending',
      start_date: new Date().toISOString(),
      end_date: new Date(Date.now() + duration * 24 * 60 * 60 * 1000).toISOString()
    }])
    .select('*')
    .maybeSingle();

  if (error) {
    console.error('Subscription creation error:', error);
    throw error;
  }
  
  return subscription;
};

export const getUserClientInfo = async (userEmail: string) => {
  const { data: schoolUserData, error: schoolUserError } = await supabase
    .from('school_users')
    .select('school_id')
    .eq('email', userEmail)
    .maybeSingle();
  
  if (schoolUserError) throw schoolUserError;
  if (!schoolUserData) {
    throw new Error("No school user found for your account. Please contact support.");
  }

  const { data: clientData, error: clientError } = await supabase
    .from('clients')
    .select('id')
    .eq('school_id', schoolUserData.school_id)
    .maybeSingle();

  if (clientError) throw clientError;
  if (!clientData) {
    throw new Error("No client found for your school. Please contact support.");
  }

  return { schoolId: schoolUserData.school_id, clientId: clientData.id };
};

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};
